import React, { Component } from 'react';
import './index.css';

class Bubble extends Component {
  render() {
    return <div className="bubbleProgressIndicator progressIndicatorPlaying">
  <span></span><span></span>
  <span></span><span></span>
  <span></span><span></span>
  <span></span><span></span>
  <span></span><span></span>
  <span></span><span></span>
  <span></span><span></span>
  <span></span><span></span>
  <span></span><span></span>
  <span></span><span></span>
  <span></span><span></span>
  <span></span><span></span>
</div>
  }
}

export default Bubble;



// WEBPACK FOOTER //
// ./src/components/Bubble/index.js